import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-suscribe-plus-confirmation-modal',
  templateUrl: './suscribe-plus-confirmation-modal.component.html',
  styleUrls: ['./suscribe-plus-confirmation-modal.component.scss']
})
export class SuscribePlusConfirmationModalComponent {

  @Output()
  emitFirstButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  emitSecondButton: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) { }

  public actionFirstButton(): void {
    this.emitFirstButton.emit(true);
    this.activeModal.close();
  }

  public actionSecondButton(): void {
    this.emitSecondButton.emit(true);
    this.activeModal.close();
  }
}
